import config from "@/config/index";
import api from "../../utils/axios-util";
import * as mutation_type from "../mutation-types";
const state = config.PauseCode;

const mutations = {
   
    [mutation_type.CommitNothing]: () => { }
};
const actions = {
    GetAppointments: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                // let skip = payload.skip;
                // let take = payload.take;
                
                api.get(`/appointments?fromDate=${payload.fromDate}`).then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    GetMeetings: ({ commit }, filterQuery) => {
        return new Promise((resolve, reject) => {

            const apiUrl = `/asterdialer/meetings?${new URLSearchParams(filterQuery).toString()}`;
            api.get(apiUrl)
                .then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    Popup: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
               
                api.get(`/popup?phone_number=${payload.phone_number}&module=tickets&template_name=undefined&user=${payload.user}`).then(response => {
                    commit(mutation_type.CommitNothing, {});
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
   
    insertAppointment: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/appointment/schedule`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    insertMeeting: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/asterdialer/meeting/schedule`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    deletemeeting: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .delete(`/meetings/delete/${payload}`)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    updateMeeting: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                const id = payload.id;
                delete payload.id;
                delete payload.campaign
                delete payload.module
                delete payload.phone_number
                api
                    .put(`/meetings/update/${id}`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    findlead: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                
                api
                    .get(`/records?phone_number=${payload.phone_number}&template_name=${payload.template}&id=`, payload)
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    meetingCheckcondition: ({ commit }, query) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/asterdialer/meetings/condition`,{ params:query })
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    fetchleads: ({ commit }, query) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/contact/template`,{ params:query })
                    .then(response => {
                        commit(mutation_type.CommitNothing, {});
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
};
export default {
    state,
    
    mutations,
    actions
};